import React from 'react';
import { Text } from '@realm-kf/halcyon-components-react';
import { dataTestId } from '@hip/test-attributes';
import { useSelector } from 'react-redux';
import { getIsFeatureEnabledByConst } from '@hip/feature-toggles';
import { Features } from '@hip/interfaces';
import { Progress } from '../progress/progress';
import { useBookingSteps } from '../../hooks/useBookingSteps';
import { getJourneyBuilderUrl } from '../../core/utils/selectors';
import styles from './styles.css';
var Steps = function () {
    var _a = useBookingSteps(), currentStepNumber = _a.currentStepNumber, totalSteps = _a.totalSteps;
    var getIsJourneyBuilderEnabled = getIsFeatureEnabledByConst(Features.JOURNEY_BUILDER);
    var journeyBuilderEnbled = useSelector(getIsJourneyBuilderEnabled);
    var journeyBuilderUrl = useSelector(getJourneyBuilderUrl);
    var showSteps = !(journeyBuilderEnbled && journeyBuilderUrl);
    return (showSteps &&
        Boolean(currentStepNumber) && (React.createElement("div", { className: styles.StepsWrapper, "data-testid": dataTestId.ab.header.stepProgressBar },
        React.createElement(Text, { as: "p", weight: "bold", classes: styles.StepsText, size: "medium" },
            "Step ",
            currentStepNumber,
            " of ",
            totalSteps),
        React.createElement(Progress, { percentage: (currentStepNumber / totalSteps) * 100 }))));
};
export { Steps };
